import { render } from "./LoginForm.vue?vue&type=template&id=95e0a2fc&scoped=true"
import script from "./LoginForm.vue?vue&type=script&lang=js"
export * from "./LoginForm.vue?vue&type=script&lang=js"

import "./LoginForm.vue?vue&type=style&index=0&id=95e0a2fc&scoped=true&lang=css"

import exportComponent from "/prj/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-95e0a2fc"]])

export default __exports__